(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gm-foundation"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const configNode = document.getElementById('GmConfig');
    const config = configNode ? JSON.parse(configNode.textContent) : {};
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const behavior = () => reduced.matches ? 'instant' : 'smooth';
    let toastTimer;
    const toast = (message) => {
      const node = document.getElementById('GmToast');
      if (!node) return;
      clearTimeout(toastTimer);
      node.textContent = message;
      node.classList.add('is-visible');
      toastTimer = setTimeout(() => node.classList.remove('is-visible'), 4500);
    };
    const request = async (url, options = {}) => {
      const response = await fetch(url, {credentials:'same-origin', ...options});
      const data = await response.json();
      if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || config.error);
      return data;
    };
    document.addEventListener('click', (event) => {
      const close = event.target.closest('[data-close-dialog]');
      if (close) close.closest('dialog')?.close();
      const zoom = event.target.closest('[data-zoom]');
      if (zoom) {
        const dialog = document.getElementById('GmZoom');
        if (!dialog?.showModal) return;
        event.preventDefault();
        const img = new Image();
        img.alt = zoom.querySelector('img')?.alt || '';
        img.src = zoom.dataset.zoom;
        dialog.querySelector('[data-zoom-image]').replaceChildren(img);
        dialog.showModal();
      }
      document.querySelectorAll('.gm-menu[open],.gm-filter-panel[open]').forEach(node => {
        if (!node.contains(event.target)) node.open = false;
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') document.querySelectorAll('.gm-menu[open],.gm-filter-panel[open]').forEach(node => {
        node.open = false;
        node.querySelector('summary')?.focus();
      });
    });
    document.addEventListener('change', (event) => {
      if (event.target.matches('[data-sort]')) event.target.form.requestSubmit();
    });
    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('form[data-gm-add]');
      if (!form || !config.add) return;
      event.preventDefault();
      if (form.dataset.submitting === 'true' || form.closest('gm-product')?.getAttribute('aria-busy') === 'true') return;
      if (!form.reportValidity()) return;
      const buyNow = event.submitter?.hasAttribute('data-buy-now');
      const formError = form.querySelector('[data-form-error]');
      if (formError) formError.textContent = '';
      const body = new FormData(form);
      body.delete('return_to');
      const buttons = Array.from(form.elements).filter(node => node.tagName === 'BUTTON' && node.type === 'submit').map(node => [node,node.disabled]);
      buttons.forEach(([node]) => node.disabled = true);
      form.dataset.submitting = 'true';
      form.setAttribute('aria-busy','true');
      let added = false;
      try {
        await request(`${config.add}.js`, {method:'POST', body, headers:{Accept:'application/json'}});
        added = true;
        if (buyNow) {
          window.location.assign(`${config.root}checkout`);
          return;
        }
        toast(config.added);
        const [cartResult, sectionResult] = await Promise.allSettled([
          request(`${config.cart}.js`),
          request(`${config.root}?sections=gm-cart-drawer`)
        ]);
        if (cartResult.status === 'fulfilled') document.querySelectorAll('[data-cart-count]').forEach(node => node.textContent = String(cartResult.value.item_count));
        if (sectionResult.status === 'fulfilled' && sectionResult.value['gm-cart-drawer']) {
          const html = new DOMParser().parseFromString(sectionResult.value['gm-cart-drawer'],'text/html');
          const replacement = html.getElementById('GmCartDrawer');
          const current = document.getElementById('GmCartDrawer');
          if (replacement && current) {
            current.replaceWith(replacement);
            if (replacement.showModal) replacement.showModal();
          }
        }
      } catch (error) {
        if (added) toast(config.added);
        else {
          if (formError) formError.textContent = error.message || config.error;
          toast(error.message || config.error);
        }
      } finally {
        if (!added || !buyNow) {
          buttons.forEach(([node,wasDisabled]) => {if (node.isConnected) node.disabled = wasDisabled;});
          delete form.dataset.submitting;
          form.removeAttribute('aria-busy');
        }
      }
    });
    class Quantity extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-step]');
          if (!button) return;
          const input = this.querySelector('input');
          const direction = Number(button.dataset.step);
          const step = Number(input.step) || 1;
          const min = Number(input.min) || 0;
          const max = input.max ? Number(input.max) : Infinity;
          input.value = String(Math.max(min, Math.min(max, (Number(input.value) || min) + direction * step)));
          input.dispatchEvent(new Event('change',{bubbles:true}));
        });
      }
    }
    class Product extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.sequence = 0;
        this.addEventListener('click', event => {
          const option = event.target.closest('[data-option-id]');
          if (option) {event.preventDefault(); this.selectOption(option);}
          const thumb = event.target.closest('[data-thumbnail]');
          if (thumb) {
            event.preventDefault();
            const gallery = this.querySelector('[data-gallery]');
            const image = this.querySelector(`[data-media-id="${CSS.escape(thumb.dataset.thumbnail)}"]`);
            if (image) gallery.scrollTo({left:image.offsetLeft - gallery.offsetLeft,behavior:behavior()});
            this.querySelectorAll('[data-thumbnail]').forEach(node => node.setAttribute('aria-current',String(node === thumb)));
          }
        });
        this.bindGallery();
      }
      disconnectedCallback() {this.controller?.abort();this.galleryObserver?.disconnect();}
      bindGallery() {
        this.galleryObserver?.disconnect();
        const gallery = this.querySelector('[data-gallery]');
        if (!gallery || !('IntersectionObserver' in window)) return;
        this.galleryObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.querySelectorAll('[data-thumbnail]').forEach(node => node.setAttribute('aria-current',String(node.dataset.thumbnail === entry.target.dataset.mediaId)));
            gallery.querySelectorAll('video').forEach(video => {if (!entry.target.contains(video)) video.pause();});
          });
        },{root:gallery,threshold:.6});
        gallery.querySelectorAll('[data-media-id]').forEach(node => this.galleryObserver.observe(node));
      }
      async selectOption(option) {
        if (this.querySelector('form[data-submitting="true"]')) return;
        const destination = option.dataset.productUrl;
        if (destination && new URL(destination,location.origin).pathname !== new URL(this.dataset.url,location.origin).pathname) {
          window.location.assign(option.href);return;
        }
        this.controller?.abort();
        this.controller = new AbortController();
        const sequence = ++this.sequence;
        const focusId = option.dataset.optionId;
        this.querySelectorAll(`[data-option-position="${option.dataset.optionPosition}"]`).forEach(node => {
          node.dataset.selected = String(node === option);
          node.classList.toggle('is-selected',node === option);
          node.setAttribute('aria-current',String(node === option));
        });
        const ids = Array.from(this.querySelectorAll('[data-option-id][data-selected="true"]')).map(node => node.dataset.optionId);
        const url = new URL(this.dataset.url,location.origin);
        url.searchParams.set('option_values',ids.join(','));
        url.searchParams.set('section_id',this.dataset.section);
        const quantity = this.querySelector('[name="quantity"]')?.value;
        const openStates = Array.from(this.querySelectorAll('.gm-product-accordions details')).map(node => node.open);
        this.setAttribute('aria-busy','true');
        this.querySelectorAll('button[type="submit"]').forEach(node => node.disabled = true);
        const errorNode = this.querySelector('[data-variant-error]');
        if (errorNode) errorNode.textContent = '';
        try {
          const response = await fetch(url,{signal:this.controller.signal,credentials:'same-origin'});
          if (!response.ok) throw new Error(config.variantError);
          const html = new DOMParser().parseFromString(await response.text(),'text/html');
          const replacement = html.querySelector('gm-product');
          if (sequence !== this.sequence) return;
          if (!replacement) throw new Error(config.variantError);
          this.innerHTML = replacement.innerHTML;
          this.dataset.variant = replacement.dataset.variant;
          this.dataset.url = replacement.dataset.url;
          const input = this.querySelector('[name="quantity"]');
          if (input && quantity) {
            const min = Number(input.min) || 1, step = Number(input.step) || 1, max = input.max ? Number(input.max) : Infinity;
            input.value = String(Math.max(min,Math.min(max,min + Math.floor((Number(quantity)-min)/step)*step)));
          }
          this.querySelectorAll('.gm-product-accordions details').forEach((node,index) => node.open = openStates[index] ?? node.open);
          this.querySelector(`[data-option-id="${CSS.escape(focusId)}"]`)?.focus({preventScroll:true});
          const historyUrl = new URL(location.href);
          historyUrl.searchParams.delete('option_values');
          if (this.dataset.variant) historyUrl.searchParams.set('variant',this.dataset.variant);
          else {historyUrl.searchParams.delete('variant');historyUrl.searchParams.set('option_values',ids.join(','));}
          history.replaceState({},'',historyUrl);
          this.bindGallery();
          window.Shopify?.PaymentButton?.init?.();
        } catch (error) {
          if (error.name !== 'AbortError' && sequence === this.sequence) {
            const node = this.querySelector('[data-variant-error]');
            if (node) node.textContent = config.variantError;
          }
        } finally {if (sequence === this.sequence) this.removeAttribute('aria-busy');}
      }
    }
    class Slideshow extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.rail = this.querySelector('[data-slides]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.index = 0;
        this.paused = reduced.matches;
        if (this.slides.length < 2) return;
        this.addEventListener('click',event => {
          if (event.target.closest('[data-slide-next]')) this.go(this.index+1);
          if (event.target.closest('[data-slide-prev]')) this.go(this.index-1);
          const dot = event.target.closest('[data-slide-to]');
          if (dot) this.go(Number(dot.dataset.slideTo));
          const pause = event.target.closest('[data-slide-pause]');
          if (pause) {
            this.paused = !this.paused;
            pause.setAttribute('aria-label',this.paused ? pause.dataset.playLabel : pause.dataset.pauseLabel);
            pause.setAttribute('aria-pressed',String(this.paused));
          }
        });
        this.rail.addEventListener('scroll',() => {
          this.index = Math.round(this.rail.scrollLeft/this.rail.clientWidth);
          this.querySelectorAll('[data-slide-to]').forEach(node => node.setAttribute('aria-current',String(Number(node.dataset.slideTo)===this.index)));
          this.slides.forEach((node,index) => {node.inert = index !== this.index;});
        },{passive:true});
        this.slides.forEach((node,index) => {node.inert = index !== 0;});
        this.addEventListener('focusin',() => this.focused = true);
        this.addEventListener('focusout',() => this.focused = false);
        this.addEventListener('mouseenter',() => this.hovered = true);
        this.addEventListener('mouseleave',() => this.hovered = false);
        if (this.dataset.autoplay === 'true') this.timer = setInterval(() => {
          if (!this.paused && !this.focused && !this.hovered && !document.hidden && !reduced.matches) this.go(this.index+1);
        },Math.max(4000,Number(this.dataset.interval)||7000));
      }
      go(index){this.index=(index+this.slides.length)%this.slides.length;this.rail.scrollTo({left:this.index*this.rail.clientWidth,behavior:behavior()});}
      disconnectedCallback(){clearInterval(this.timer);}
    }
    class Countdown extends HTMLElement {
      connectedCallback() {
        const raw = this.dataset.ends || '';
        if (!/T.*(Z|[+-]\d{2}:\d{2})$/.test(raw)) return;
        this.end = Date.parse(raw);
        if (!Number.isFinite(this.end)) return;
        this.hidden = false;
        this.tick();
        if (this.end > Date.now()) this.timer = setInterval(() => this.tick(),1000);
      }
      tick() {
        let left = Math.max(0,Math.floor((this.end-Date.now())/1000));
        if (left <= 0) {
          clearInterval(this.timer);
          this.querySelector('.gm-countdown-grid').hidden = true;
          this.querySelector('p').hidden = true;
          this.querySelector('[data-expired]').hidden = false;
          return;
        }
        const times = {days:Math.floor(left/86400),hours:Math.floor(left%86400/3600),minutes:Math.floor(left%3600/60),seconds:left%60};
        Object.entries(times).forEach(([key,value]) => this.querySelector(`[data-time="${key}"]`).textContent=String(value).padStart(2,'0'));
      }
      disconnectedCallback(){clearInterval(this.timer);}
    }
    class Recommendations extends HTMLElement {
      connectedCallback() {
        if (this.loaded) return;
        this.loaded = true;
        const fetchRecommendations = async () => {
          try {
            const response = await fetch(this.dataset.url,{credentials:'same-origin'});
            if (!response.ok) return;
            const html = new DOMParser().parseFromString(await response.text(),'text/html');
            const content = html.querySelector('gm-recommendations');
            if (content?.innerHTML.trim()) this.innerHTML = content.innerHTML;
          } catch (_) {}
        };
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {this.observer.disconnect();fetchRecommendations();}
          },{rootMargin:'500px'});
          this.observer.observe(this);
        } else fetchRecommendations();
      }
      disconnectedCallback(){this.observer?.disconnect();}
    }
    class Shipping extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const form=this.querySelector('form'),country=this.querySelector('[data-country]'),province=this.querySelector('[data-province]');
        const update = () => {
          const options = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]');
          province.replaceChildren(...options.map(([value,label])=>new Option(label,value)));
          province.disabled = options.length === 0;
          this.querySelector('[data-province-wrap]').hidden = options.length === 0;
        };
        country.value = country.querySelector('option[value="United States"]') ? 'United States' : country.options[0]?.value;
        update();
        country.addEventListener('change',update);
        form.addEventListener('submit',async event => {
          event.preventDefault();
          const submit=form.querySelector('button[type=submit]'),result=this.querySelector('[data-rates]');
          submit.disabled=true;form.setAttribute('aria-busy','true');result.textContent='';
          try {
            const query = new URLSearchParams(new FormData(form));
            const data = await request(`${config.cart}/shipping_rates.json?${query}`);
            if (!Array.isArray(data.shipping_rates) || !data.shipping_rates.length) {result.textContent=config.noRates;return;}
            const ul = document.createElement('ul');
            data.shipping_rates.forEach(rate => {
              const li=document.createElement('li');
              li.textContent=`${rate.name}: ${new Intl.NumberFormat(config.locale,{style:'currency',currency:config.currency}).format(Number(rate.price))}`;
              ul.append(li);
            });
            result.replaceChildren(ul);
          } catch (_) {result.textContent=config.shippingError;}
          finally {submit.disabled=false;form.removeAttribute('aria-busy');}
        });
      }
    }
    for (const [name,definition] of [['gm-quantity',Quantity],['gm-product',Product],['gm-slideshow',Slideshow],['gm-countdown',Countdown],['gm-recommendations',Recommendations],['gm-shipping',Shipping]]) {
      if (!customElements.get(name)) customElements.define(name,definition);
    }
    document.addEventListener('shopify:block:select',event=>{
      const slider=event.target.closest('gm-slideshow');
      if (!slider) return;
      const index=slider.slides.indexOf(event.target.closest('[data-slide]'));
      if(index>=0){slider.paused=true;slider.go(index);}
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();
  } catch(e) { console.error(e); }
})();

})();
